export class TokenAutenticazioneVO {
  token: string;

  dataCreazione: string;

  secondiValidita: number;

  refreshToken: string;

  tipoToken: string;
}
